/* dev-hero-slider — wires per-slide prev/next buttons to the section's
   Swiper instance. Each slide renders its own pair of buttons inside its
   __buttons-container; only the active slide is visible at a time, so we
   bind every button in the section so whichever slide is showing remains
   functional. */

function wireDevHeroSlider(section) {
  const container = section.querySelector('swiper-container');
  if (!container) return;

  const tick = () => {
    const swiper = container.swiper;
    if (!swiper) {
      requestAnimationFrame(tick);
      return;
    }
    section.querySelectorAll('.dev-hero-slide__nav-prev').forEach((btn) => {
      if (btn.dataset.devNavBound === '1') return;
      btn.dataset.devNavBound = '1';
      btn.addEventListener('click', () => swiper.slidePrev());
    });
    section.querySelectorAll('.dev-hero-slide__nav-next').forEach((btn) => {
      if (btn.dataset.devNavBound === '1') return;
      btn.dataset.devNavBound = '1';
      btn.addEventListener('click', () => swiper.slideNext());
    });
  };
  tick();
}

function initAllDevHeroSliders(root) {
  (root || document).querySelectorAll('.dev-hero-slider').forEach(wireDevHeroSlider);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAllDevHeroSliders());
} else {
  initAllDevHeroSliders();
}

document.addEventListener('shopify:section:load', (event) => {
  initAllDevHeroSliders(event.target);
});
